import { ErrorReporter } from '../errorReporter.type';

const performanceTimingObjectToGeneralObject = (performanceTimingObject:object) => JSON.parse(JSON.stringify(performanceTimingObject));

export const initRealUserMonitoring = (countryCode:string, templateName:string, monitoringEndpoint:string, errorProvider:ErrorReporter) => {
  window.addEventListener('unload', () => {
    try {
      const { timing } = window.performance;
      const { navigationStart } = timing;
      const navigationTiming = Object.keys(performanceTimingObjectToGeneralObject(timing))
      // @ts-ignore
        .filter(key => key !== 'navigationStart' && timing[key] !== 0)
        .reduce((acc, key) => ({
          ...acc,
          // @ts-ignore
          [key]: timing[key] - navigationStart,
        }), {});
      const customTiming = window.performance.getEntriesByType('paint')
        .concat(window.performance.getEntriesByType('mark'))
        .filter(entry => entry.startTime !== 0)
        .reduce((acc, entry) => ({
          ...acc,
          [entry.name]: entry.startTime + entry.duration,
        }), {});
      const customDuration = window.performance.getEntriesByType('measure')
        .filter(entry => entry.duration !== 0)
        .reduce((acc, entry) => ({
          ...acc,
          [entry.name]: entry.duration,
        }), {});
      window.navigator.sendBeacon(monitoringEndpoint, JSON.stringify({
        countryCode,
        pageType: templateName,
        userAgent: window.navigator.userAgent,
        ...navigationTiming,
        ...customTiming,
        ...customDuration,
      }));
    } catch (e) {
      errorProvider.reportException(e);
    }
  });
};
